import { useState, useEffect } from "react";
import EventCard from "../component/EventCard";
import EventCardSpecial from "../component/EventCardSpecial";
import InputCard from "../component/InputCard";
import InputCardNonMember from "../component/InputCardNonMember";
import { useDecodedParams } from "../misc/utils";
import { useForm, Controller } from "react-hook-form";
import { Button, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import ExampleComp from "../component/ExampleComp";
import { useAws } from "../aws";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Backdrop from "@mui/material/Backdrop";
import CustomPopup from "../component/CustomPopup";
import { useSetMember } from "../misc/utils";

const EventDetailPage = () => {
  const { x_api_key, x_api_key_cms, apiStage } = useAws();
  const { t } = useTranslation();
  const { id } = useDecodedParams();
  // console.log(id);
  const [popup, setPopup] = useState({ show: false, message: "" });
  const { awsHttp, uploadToS3 } = useAws();
  const [eventId, setEventId] = useState({});

  const [isLoading, setIsLoading] = useState(false);
  const [specialCase, setSpecialCase] = useState("no");
  const [memberCase, setMemberCase] = useState("no");
  const [paymentMethod, setPaymentMethod] = useState("PAY at SITE");
  const hookForm = useForm({ mode: "all" });
  const { handleSubmit, clearErrors, setValue, getValues, trigger, reset } =
    hookForm || {};

  const navigate = useNavigate();

  const mem = useSetMember();
  const [memberType, setMemberType] = useState(mem.getMember());

  const [data, setData] = useState({});
  const [fetched, setFetched] = useState(false);
  const [price, setPrice] = useState(0);

  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleToggle = () => {
    setOpen(!open);
  };

  const inputCardProps = {
    hookForm,
    paymentItmeProps: {
      paymentMethod,
      setPaymentMethod,
    },
    price,
  };

  const onSubmit = (data) => {
    if (data?.files?.length > 0) {
      // console.log("Try upload to S3", data.files);
      data.files.forEach((item, i) => {
        const path = "private/supdoc/" + item.data.filename;
        uploadToS3(item.file, path)
          .then((res) => {
            // console.log(res);
            // if (i === data.files.length - 1) submitData(data);
            if (i === data.files.length - 1) proceedEnrollment(data);
          })
          .catch((e) => {
            // console.log(e);
          });
      });
    } else {
      proceedEnrollment(data);
      // submitData(data);
    }
  };

  const proceedEnrollment = async (input) => {
    console.log(input);

    let _data = { ...input, paymentMethod: paymentMethod };
    if (input.skuIndex != null) {
      _data["event_id"] = id;
      setEventId(id);
      _data["skuName"] = data.sku[_data.skuIndex]?.name;
      _data["NN2C"] =
        data.sku[_data.skuIndex].options[_data.optionIndex].price === 0 ||
        _data.paymentMethod === "PAY at SITE"
          ? true
          : false;
    }
    setIsLoading(true);
    try {
      const res = await axios.post(
        apiStage + "/user/check_member",
        processEventEnrollmentData(_data),
        {
          headers: {
            "x-api-key": x_api_key,
            "Content-Type": "application/json",
          },
        }
      );

      _data["userGoodToGo"] = res.data.result;
      _data["userGoodToGoMessage"] = res.data.message;
      _data["promoMoney"] = res.data.promo_money;
      console.log(res);

      console.log(_data);
      setIsLoading(false);
    } catch (error) {
      console.error("Error while checking member status:", error);
    }
    // console.log("wtf is going on");
    // console.log(_data);
    handleStorageEvent(_data);

    // window.sessionStorage.setItem("event", JSON.stringify(_data));
    // navigate("/confirmation/event");
  };

  const processEventEnrollmentData = (data) => {
    const trial = data.option.trial;
    // console.log("here is the data");
    // console.log(data);
    const p = {
      event_id: data.event_id,
      detail: {
        name: {
          prefix: data.prefix,
          en_full_name: data.parentname,
        },
        child_full_name: data.IDname,
        child_other_name: data.othername,
        gender: data.gender,
        contact_email: data.confirmEmail,
        contact_phone: data.phoneNumber,
        emergency_contact_phone_number: data.emergencyContactPhoneNumber,
        emergency_contact_full_name: data.emergencyname,
        birth_date: data.date,
        supporting_doc: data?.files?.length
          ? data.files.map((file) => file.data.filename)
          : [],
      },
      sku: data.skuIndex,
      option: data.optionIndex,
      promo_terms: data["pi-0"] ? "yes" : "no",
      film_terms: data["pi-1"] ? "yes" : "no",
      payment_method: data.paymentMethod,
      promo_code: data.promo_code,
      class_type:
        trial === true
          ? "trial"
          : data.option.memberStatus === "special"
          ? "special"
          : "normal",
      member_status: memberType,
    };
    // console.log("here is the prepared data");
    // console.log(p);
    return p;
  };

  const handleStorageEvent = (data) => {
    // console.log(data);
    const date = new Date(data.date);
    const formattedDate = `${date.getDate()}/${
      date.getMonth() + 1
    }/${date.getFullYear()}`;
    data.date = formattedDate;
    if (data.userGoodToGo === true) {
      window.sessionStorage.setItem("event", JSON.stringify(data));
      // Check your condition here
      navigate("/confirmation/event");
    } else {
      // Show an error message using the custom popup
      setPopup({ show: true, message: data.userGoodToGoMessage });
    }
  };

  const handleClosePopup = () => {
    setPopup({ show: false, message: "" });
  };

  const submitData = (data) => {
    const requestBody = {
      event_id: id,
      detail: {
        name: {
          prefix: data.prefix,
          zh_last_name: data.chineseLastname,
          zh_first_name: data.chineseFirstname,
          en_last_name: data.englishLastname,
          en_first_name: data.englishFirstame,
        },
        gender: data.gender,
        contact_email: data.confirmEmail,
        contact_phone: data.phoneNumber,
        contact_phone_region: data.phoneType,
        birth_year: parseInt(data.birthYear),
        birth_month: parseInt(data.birthMonth.split("月")[0]),
        address: data.livingArea,
        job: data.job,
        supporting_doc: data?.files?.length
          ? data.files.map((file) => file.data.filename)
          : [],
      },
      sku: data.skuIndex,
      option: data.optionIndex,
    };
    awsHttp({
      HTTPRequestMethod: "POST",
      APIFunction: "user/applyevent",
      requestBody: requestBody,
    }).then((res) => {
      // console.log(res);
    });
  };

  const printFormData = (event) => {
    if (event.ctrlKey && event.altKey && event.key === "l") {
      // console.log(getValues());
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", printFormData);
  }, []);

  useEffect(() => {
    if (!id) return;
    // console.log(process.env.REACT_APP_ENV);
    awsHttp({
      HTTPRequestMethod: "POST",
      APIFunction: "user/get_event_detail",
      requestBody: { event_id: id },
    }).then((res) => {
      setFetched(true);
      changeStatus(res.data.body);
      setData({ ...res.data.body });
      // console.log({ ...res.data.body });
      setSpecialCase(
        res.data.body.is_special ? res.data.body.is_special : "no"
      );
    });
  }, [id]);

  const statusTextList = [
    {
      value: "active",
      text: "active",
      fullValue: "full",
      full: "full",
      expiredValue: "expired",
      expired: "expired",
    },
    { value: "pause", text: "pause" },
    { value: "stop", text: "stop" },
    { value: "cancel", text: "cancel" },
  ];

  const [status, setStatus] = useState("");
  const [statusText, setStatusText] = useState("");

  const changeStatus = (data) => {
    setStatus(getStatus(data));
    setStatusText(getStatusText(data));
  };

  const getStatus = ({ status, limit, current_user, expires_at }) => {
    switch (status) {
      case statusTextList[0].value:
        if (current_user >= limit) {
          return statusTextList[0].fullValue;
        } else if (new Date().getTime() >= expires_at) {
          return statusTextList[0].expiredValue;
        }
        return statusTextList[0].value;
      case statusTextList[1].value:
        return statusTextList[1].value;
      case statusTextList[2].value:
        return statusTextList[2].value;
      case statusTextList[3].value:
        return statusTextList[3].value;
      default:
        return statusTextList[0].value;
    }
  };
  const getStatusText = ({ status, limit, current_user, expires_at }) => {
    switch (status) {
      case statusTextList[0].value:
        if (current_user >= limit) {
          return statusTextList[0].full;
        } else if (new Date().getTime() >= expires_at) {
          return statusTextList[0].expired;
        }
        return statusTextList[0].text;
      case statusTextList[1].value:
        return statusTextList[1].text;
      case statusTextList[2].value:
        return statusTextList[2].text;
      case statusTextList[3].value:
        return statusTextList[3].text;
      default:
        return statusTextList[0].text;
    }
  };

  const checkShouldShow = (data) => {
    const { current_user, limit, status, expires_at } = data;
    if (status !== "pasue") return false;
    if (current_user >= limit) {
      return false;
    } else if (new Date().getTime() >= expires_at) {
      return false;
    }
    return "active";
  };
  // console.log(specialCase);
  // if(isLoading)return <CircularProgress/>
  return (
    <div className="page-view event-detail">
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open || isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      {id ? (
        <div style={{ position: "relative", marginTop: 32 }}>
          {status === "active" ? (
            <form
              key="userInfoForm"
              id="userInfoForm"
              onSubmit={handleSubmit(onSubmit)}
              onKeyPress={(e) => {
                e.key === "Enter" && e.preventDefault();
              }}
            >
              {data && data.name ? (
                <Controller
                  key="option"
                  name="option"
                  control={hookForm.control}
                  defaultValue=""
                  render={({ field, fieldState: { error } }) => {
                    return specialCase === "yes" ? (
                      <EventCardSpecial
                        memberStatus={memberType}
                        memberType={memberType}
                        setMemberStatus={setMemberType}
                        data={data}
                        xc="mb-6"
                        error={!!error}
                        setValue={setValue}
                        setPrice={setPrice}
                        trigger={trigger}
                      />
                    ) : (
                      <EventCard
                        memberStatus={memberType}
                        memberType={memberType}
                        setMemberStatus={setMemberType}
                        data={data}
                        xc="mb-6"
                        error={!!error}
                        setValue={setValue}
                        setPrice={setPrice}
                        trigger={trigger}
                      />
                    );
                  }}
                  rules={{
                    required: "Option Null",
                  }}
                />
              ) : (
                ""
              )}

              {memberType === "member" && <InputCard {...inputCardProps} />}
              {memberType === "nonmember" && (
                <InputCardNonMember {...inputCardProps} />
              )}
              <div className={`my-5 btns-gp-div`}>
                <Button
                  sx={{ marginRight: 2 }}
                  onClick={() => reset()}
                  style={{ borderColor: "#fa8123", color: "#fa8123" }}
                >
                  {t("Clear")}
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  style={{
                    backgroundColor: "#FFA836", // Change this color to your desired color
                    color: "#FFFFFF", // Change the text color if needed
                  }}
                >
                  {t("Submit")}
                </Button>
              </div>
            </form>
          ) : fetched ? (
            <>
              <p style={{ marginTop: "12px", fontSize: "16px" }}>
                {t(`disabled_${status}`)}
                <a
                  href="mailto:cs@elite-paradise.tech"
                  style={{ textDecoration: "none", color: "#1976d2" }}
                >
                  {" "}
                  cs@elite-paradise.tech
                </a>
                {t("learn more")}
              </p>
              <img
                style={{ maxWidth: "320px", marginTop: "24px" }}
                src={data.poster}
                alt="event-detail-poster"
              />
            </>
          ) : null}
          {fetched ? null : <CircularProgress sx={{ marginTop: "20px" }} />}
        </div>
      ) : (
        <>
          {/* <img
            className="logo"
            src="/EP_logo_withwords-01.png"
            alt="pause-and-breathe-logo"
          /> */}
          <p
            style={{
              marginTop: "12px",
              fontSize: "16px",
              textAlign: "center",
              lineHeight: "32px",
            }}
          >
            {t("Event Page diabled")}
            <a
              href="https://www.mygympremium.com/"
              style={{ textDecoration: "none", color: "#1976d2" }}
            >
              {" "}
              www.mygympremium.com
            </a>
            <br />
            {t("Event Page diabled Email")}
            <a
              href="mailto:cs@elite-paradise.tech"
              style={{ textDecoration: "none", color: "#1976d2" }}
            >
              {" "}
              cs@elite-paradise.tech
            </a>
          </p>
          {data.poster && data.poster !== "" && data.poster !== undefined ? (
            <img
              style={{ maxWidth: "320px", marginTop: "24px" }}
              src={data.poster}
              alt="event-detail-poster"
            />
          ) : null}
        </>
      )}
      <CustomPopup
        message={popup.message}
        show={popup.show}
        handleClose={handleClosePopup}
      />
    </div>
  );
};

export default EventDetailPage;
